module.exports = __webpack_public_path__ + "img/1.2399f1e6.svg";